module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/7-1170dbf04f014d8397ba313c8e99b334.jpg";